var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 43,
    height: 46,
    viewBox: "0 0 43 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "icon_\\u30E6\\u30FC\\u30B6\\u30FC",
    x: 3,
    y: 1,
    width: 37,
    height: 43,
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAArCAYAAAD/lEFzAAAB/UlEQVRYhe2YvUscQRiHn7sIEoMfGDQnGlQsBCWVImjAxEYtNWBnYa+l/4GNhYJgIQgSEawU7ARRTCoLG4OxUEFFVMQmBD8LP5ljTpZDd/dm3sltkQd+1e7NPDOzMzczMcwpBbqBL8An4CNwC+wDG8AKsADcW9QRmrfACHAFPAbkAOh3LdQEHIaQSc8yUOBCqNVAxhs1rIWSQmXAg6WUyq8wlb0JKbUKlNu1K0lC1/nDtqBOgR5Kz3tbqZ8OpEZthBIOhFSO/CqNB0h12LTIhwqg0lSqwpGUouq1B0FSufIuwWUHSV3Juzxz+dqDIKltNz5Jdk1/qP58bxzMvi2/SoN66kZvP6SZtC2vXriXzqUaOCUo1SMlpdgREPouKaQo1jPGVGhOWiiFmo3zBkJDroS8fAM2Q8gsAg2ZFm5zmlF81dvkWqAEuANOgd96Y7hpWf5/fMl0+NQx6bP+Tmr0tjbvhffU93QBnOmlZB1Ykx6KFmAa+GOxJOwBw0C1rUyd4RLgF3WMHwPyTYQGhGXScwK0ZSI07ljIm74wQhP/UCiVXj+hwSwIpdL4klBNFoUe9fKRxHuXsCR0X2DKu/R7hvYs95I3RamemnV88MyE25heYfcjIqQ4juvL1ChRpqSaIyZ1HdcbtEihpD5ETSqmp2KkyAFmgC6B/boM8PcJiNLpwaah+W0AAAAASUVORK5CYII="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.ba2c2e68cab78bc6400a20bfe625cb88.svg";
export { ForwardRef as ReactComponent };